<template>
  <div class="text-h3 primary--text mb-6 ref-title"><slot></slot></div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({});
</script>
